import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=7fd2d138&"
import script from "./trash.vue?vue&type=script&lang=js&"
export * from "./trash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd2d138')) {
      api.createRecord('7fd2d138', component.options)
    } else {
      api.reload('7fd2d138', component.options)
    }
    module.hot.accept("./trash.vue?vue&type=template&id=7fd2d138&", function () {
      api.rerender('7fd2d138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/trash.vue"
export default component.exports